export default "__VITE_PUBLIC_ASSET__ad6134a2__"